export default __webpack_public_path__ + "media/images/mailer/icon_cached-09f33ffeaf45376e58a5ec6a2065cbf3.png";